import React from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import Pagination from "@atlaskit/pagination";

function Table({
  columns,
  data,
  isLoading,
  pageSelected,
  setPageSelected,
  pages,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    pageCount,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const handleChange = (event, newPage) => {
    setPageSelected(newPage);
    gotoPage(newPage - 1);
  };

  return (
    <div className="col-span-full rounded-sm bg-white">
      <div className="px-0 py-3 md:px-3">
        {isLoading ? (
          <>
            <div className="overflow-x-auto">
              <table className="w-full table-auto">
                <thead className="rounded-sm bg-gray-50 text-xs text-gray-400">
                  {headerGroups.map((headerGroup) => {
                    const { key, ...rest } = headerGroup.getHeaderGroupProps();
                    return (
                      <tr {...rest} key={key}>
                        {headerGroup.headers.map((column) => {
                          const { key: colKey, ...colRest } =
                            column.getHeaderProps(
                              column.getSortByToggleProps(),
                            );
                          return (
                            <th
                              key={colKey}
                              className={`whitespace-nowrap px-3 py-2 font-semibold ${column.headerClassName || ""}`}
                              {...colRest}
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? " 🔽"
                                    : " 🔼"
                                  : ""}
                              </span>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
                <tbody className="divide-y divide-gray-200 text-xs">
                  {[...Array(10)].map((_, rowIndex) => (
                    <tr key={rowIndex}>
                      {columns.map((_, colIndex) => (
                        <td
                          key={colIndex}
                          className="whitespace-nowrap px-3 py-2"
                        >
                          <div className="m-1.5 h-3 w-full animate-pulse rounded-lg bg-gray-100" />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <>
            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full table-auto" {...getTableProps()}>
                <thead className="rounded-sm bg-gray-50 text-xs text-gray-400">
                  {headerGroups.map((headerGroup) => {
                    const { key, ...rest } = headerGroup.getHeaderGroupProps();
                    return (
                      <tr key={key} {...rest}>
                        {headerGroup.headers.map((column) => {
                          const { key: colKey, ...colRest } =
                            column.getHeaderProps(
                              column.getSortByToggleProps(),
                            );
                          return (
                            <th
                              key={colKey}
                              className={`whitespace-nowrap px-3 py-2 font-semibold ${column.headerClassName || ""}`}
                              {...colRest}
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? " 🔽"
                                    : " 🔼"
                                  : ""}
                              </span>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
                {/* Apply the table body props */}
                <tbody
                  className="divide-y divide-gray-200 text-xs"
                  {...getTableBodyProps()}
                >
                  {page.length > 0 ? (
                    page.map((row) => {
                      prepareRow(row);
                      const { key, ...rest } = row.getRowProps();
                      return (
                        <tr key={key} {...rest}>
                          {row.cells.map((cell) => {
                            const { key: cellKey, ...cellRest } =
                              cell.getCellProps();
                            return (
                              <td
                                className="whitespace-nowrap px-3 py-2"
                                key={cellKey}
                                {...cellRest}
                              >
                                {cell.render("Cell")}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="">
                      <td
                        colSpan={headerGroups[0]?.headers.length || 1}
                        className="max-w-screen px-4 py-10 text-center text-sm text-gray-400"
                      >
                        <div className="max-w-screen flex w-full flex-col items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-24 w-24 text-gray-300"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                            />
                          </svg>
                          <p className="mt-2 text-xs">
                            Tidak ada data ditemukan
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="mt-4 flex justify-center">
              <Pagination
                onChange={handleChange}
                defaultSelectedIndex={pageSelected}
                pages={
                  pages
                    ? pages.map((_, i) => i + 1)
                    : [...Array(pageCount)].map((_, i) => i + 1)
                }
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Table;
